import React, {useCallback, useState} from 'react';
import countries from 'svg-country-flags/countries.json';
import TitleImg from '../../images/country-select__title.png'
import NextButtonImg from "../../images/area-select__next-button.png";
import NextButtonHoverImg from "../../images/area-select__next-button--hover.png";
import OkButtonImg from "../../images/area-select__ok-button.png";
import OkButtonHoverImg from "../../images/area-select__ok-button--hover.png";
import './AreaSelectPage.scss';
import {Store} from "../../models/Store";

type P = {
    onDone: (arg: string) => void;
};

export const AreaSelectPage = (props: P) => {

    // スクロール位置を一番上にする
    window.scrollTo(0, 0);

    // 国の初期選択
    const [value, setValue] = useState('JP');

    // OK時
    const handleSubmit = useCallback(e => {
        e.preventDefault();

        // モデルに保存
        Store.smileRegister.setCountry(value);

        // コールバック
        props.onDone(value);

    }, [props, value]);

    // セレクトボックス変更時
    const handleChange = useCallback(e => {
        e.preventDefault();
        setValue(e.target.value);
    }, []);

    //
    return (
        <div className={'area-select'}>
            <h1 className='area-select__title'><img src={TitleImg} width={479} height={79} alt=""/></h1>

            <form onSubmit={handleSubmit}>

                <div className='area-select__select-container'>

                    <div className="area-select__select-wrapper">
                        <select className='area-select__select' value={value} onChange={handleChange}>
                            {
                                (() => {
                                    const list: any[] = [];
                                    for (let [code, name] of Object.entries(countries)) {
                                        list.push(<option key={code} value={code}>{name}</option>);
                                    }
                                    return list;
                                })()
                            }
                        </select>
                    </div>
                </div>

                <div>
                    <div className='area-select__start-button-container'><input type='image' width={218} height={100}
                                                                                src={value === 'JP' ? NextButtonImg : OkButtonImg}
                                                                                onMouseOver={e => e.currentTarget.src = (value === 'JP' ? NextButtonHoverImg : OkButtonHoverImg)}
                                                                                onMouseOut={e => e.currentTarget.src = (value === 'JP' ? NextButtonImg : OkButtonImg)}
                                                                                style={{cursor: 'pointer'}} alt=""/>
                    </div>
                </div>
            </form>
        </div>
    );
};